import React, { useState, useEffect } from 'react';
import { Container, Grid, FormControlLabel, Button } from '@material-ui/core';
import { CustomeAlert } from 'Components/Alert/Alert';
import {
    LOGOUT,
    CUSTOMER_SELECT_LIST,
    CUSTOMER_DELETE,
    CUSTOMER_ACTIVATE
} from 'ConstComponents';
import { useHistory } from 'react-router';
import Switch from '@material-ui/core/Switch';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Backdrop from '@material-ui/core/Backdrop';
import Loader from 'Components/Loader/Loader';
import Box from '@material-ui/core/Box';
import ReactTable from 'Components/ReactTable/ReactTable';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';

export const Customer = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [customers, setCustomers] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});

    const onClick = item => {
        var RequestObj = { CustomerID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const activate = async (item, value) => {
        var jsonObj = {
            CustomerID: item,
            IsActive: value
        };
        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoadingOpen(true);

        const response = await CUSTOMER_ACTIVATE(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) setSeverity('error');

        setIsError(true);
        selectCustomer();
    };

    const selectCustomer = async () => {
        setLoadingOpen(true);
        const response = await CUSTOMER_SELECT_LIST();
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        var data = JSON.parse(response.data);

        setCustomers(data);
    };

    useEffect(() => {
        setLoadingOpen(true);
        selectCustomer();
        createColumns();
    }, []);

    const DeleteUser = async request => {
        setIsError(false);
        setLoadingOpen(true);
        var jsonReq = JSON.stringify(request);
        const response = await CUSTOMER_DELETE(jsonReq);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) setSeverity('error');

        setIsError(true);
        selectCustomer();
    };

    const EditCustomer = async request => {
        history.push('/Customer/Edit/' + request);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'CustomerID',
            srno: true
        });

        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Mobile',
            name: 'Mobile'
        });
        columns.push({
            label: 'Address',
            name: 'Address'
        });
        columns.push({
            label: 'STB',
            name: 'STB'
        });

        columns.push({
            label: 'Reg. Date',
            name: 'DOR'
        });
        columns.push({
            label: 'Active',
            name: 'IsActive',
            options: {
                filter: false,
                sort: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const customerID = tableMeta.rowData[0];
                    return (
                        <FormControlLabel
                            value={value ? 'Yes' : 'No'}
                            control={
                                <Switch
                                    color="primary"
                                    checked={value}
                                    value={value ? 'Yes' : 'No'}
                                />
                            }
                            onChange={event => {
                                var newValue =
                                    event.target.value === 'Yes' ? false : true;
                                updateValue(newValue);
                                activate(customerID, newValue);
                            }}
                        />
                    );
                }
            }
        });

        columns.push({
            label: 'Edit',
            name: 'CustomerID',
            options: {
                filter: false,
                sort: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <EditIcon
                            variant="contained"
                            color="primary"
                            onClick={event => {
                                EditCustomer(value);
                            }}
                        />
                    );
                }
            }
        });

        columns.push({
            label: 'Delete ',
            name: 'CustomerID',
            options: {
                filter: false,
                sort: false,
                download: false,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <DeleteIcon
                            color="secondary"
                            variant="contained"
                            onClick={event => {
                                onClick(value);
                            }}
                        />
                    );
                }
            }
        });

        setMainColumns(columns);
    };

    return (
        <>
            {isError ? (
                <CustomeAlert
                    isOpen={isError}
                    message={responseMessage}
                    severity={severity}
                    onCloseCallback={alertState => {
                        setIsError(alertState);
                    }}
                />
            ) : null}

            {isAlertOpen ? (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this customer."
                    request={confirmAlertRequest}
                    positiveButtonClick={request => {
                        setIsAlertOpen(false);
                        DeleteUser(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            <Backdrop className={classes.backdrop} open={loadingOpen}>
                <Loader />
            </Backdrop>

            <Grid style={{ marginBottom: '5px', marginTop: '5px' }}>
                <Box display="flex" flexDirection="row-reverse">
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.CustomPrimaryButtonStyle}
                        href="/Customer/Add"
                    >
                        New Customer
                    </Button>
                </Box>
            </Grid>

            <ReactTable List={customers} columns={mainColumns} />
        </>
    );
};
